var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadOrange = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M2.75 2h10.5c.412 0 .75.335.75.745v1.49c0 .41-.338.745-.75.745s-.75-.335-.75-.745V3.49h-9v.745c0 .41-.337.745-.75.745S2 4.645 2 4.235v-1.49c0-.41.337-.745.75-.745zm2.251 7.451c-.229 0-.453-.103-.6-.298-.25-.33-.182-.797.15-1.043l3-2.235c.259-.194.616-.2.88-.014l3 2.097c.34.237.421.702.183 1.038-.239.336-.706.418-1.045.18L8.748 7.905l.002.057v5.96c0 .412-.335.746-.75.746s-.75-.334-.75-.745v-5.96l-1.8 1.34c-.135.1-.292.149-.449.149z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadOrange, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload_orange.47d25812.svg";
export { ForwardRef as ReactComponent };